import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AdjuntosService } from '../services/adjuntos/adjuntos.service';

const initialState = {};

const adjuntosService = new AdjuntosService();
export const adjuntosSlice = createSlice({
  name: 'adjuntos',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
  },
});

//se incluyen estas funciones en el slice ya que todos los llamados de los endpoints se manejan a traves de redux
export const getAdjuntos = createAsyncThunk('get_adjuntos', async () => {
  return adjuntosService.getAdjuntos()
});
export const getAdjuntoFullSize = createAsyncThunk('get_adjunto_full_size', async (id: number) => {
  return adjuntosService.getAdjuntoFullSize(id);
});
export const getAdjuntoThumbnail = createAsyncThunk('get_adjunto_thumbnail', async (id: number) => {
    return adjuntosService.getAdjuntoThumbnail(id);
});

export default adjuntosSlice.reducer;
